/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";
import OutboundRequestLogService from '../../service/outbound-request-log-service';
import Pasoonate from "pasoonate";
import i18n from "../../plugins/locale/i18n";
import loadDictionary from "../../plugins/locale/load-dictionary";
import { Modal } from "react-bootstrap";
import { JSONTree } from "react-json-tree";

const outboundRequestLogService = new OutboundRequestLogService();

await loadDictionary('outbound-request-log-details-window');

function DetailsOutboundRequestLogWindow({isOpenWindow, onCloseWindow, requestLogId}) {
    const [requestLog, setRequestLog] = useState(null);

    const handleClose = () => {
        onCloseWindow();
    };

    useEffect(() => {
        if(!isOpenWindow || !requestLogId) return;

        outboundRequestLogService.findOne(requestLogId).then(requestLog => {
            requestLog.created_at = requestLog?.created_at ? Pasoonate.make().gregorian().parse('yyyy-MM-dd HH:mm:ss', requestLog.created_at) : null;
            
            setRequestLog(requestLog);
        });

    }, [isOpenWindow, requestLogId]);

    return (
        <Modal show={isOpenWindow} onHide={handleClose} backdrop="static" keyboard={true} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>
                    {i18n.t("outbound-request-log-details-window.title")}
                    <span className="badge bg-success ms-2 fs-6 fw-normal">{requestLog?.status_code}</span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="border rounded mx-1">
                    <div className="border-bottom p-2">
                        <div className="text-secondary">URL</div>
                        <div dir="ltr" className="">{requestLog?.url}</div>
                    </div>
                    <div className="border-bottom p-2">
                        <div className="text-secondary">Service Name</div>
                        <div dir="ltr" className="">{requestLog?.service_name}</div>
                    </div>
                    <div className="p-2">
                        <div className="text-secondary">Execution Time</div>
                        <div dir="ltr" className="">{Number(requestLog?.execution_time).toFixed(3)}</div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12 col-12" dir="ltr">
                        <JSONTree data={requestLog?.request_payload} />
                    </div>
                    <div className="col-lg-12 col-12" dir="ltr">
                        <JSONTree data={requestLog?.response_payload} />
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default DetailsOutboundRequestLogWindow;